import { useState } from 'react'
import axios, { AxiosResponse } from 'axios'

export type Response = { result?: AxiosResponse<any>; error?: any }

const useUpload = () => {
    const [loading, setLoading] = useState(false)

    const handleSubmit = (values: any) => {
        console.log('useUpload submit', values)

        if (values.files) {
            const data = uploadTemp(values.files)
            console.log('data', data)
        }
    }

    const uploadTemp = async (files: any[]) => {
        setLoading(true)
        try {
            let uploadFile = await Promise.all(
                files.map(async (file: any, index: number) => {
                    const formData = new FormData()
                    formData.append('files', file)
                    formData.append('name', file.name)

                    const { result, error } = await callServiceUploadTemp(formData)
                    return result
                }),
            )

            setLoading(false)
            return uploadFile
        } catch (error) {
            setLoading(false)
            return { error }
        }
    }

    const callServiceUploadTemp = async (formData: any): Promise<Response> => {
        try {
            const url = `${process.env.REACT_APP_API}/api/upload/to-temp`
            const result = await axios.post(url, formData)
            return { result }
        } catch (error) {
            return { error }
        }
    }

    return { onSubmit: handleSubmit }
}

export default useUpload
